export default "__VITE_ASSET__DZto0JXh__"